import {compose} from 'redux';
import withCitiesAndStreets from 'common/components/hoc-helpers/withCitiesAndStreets';
import InspectedListPage from './InspectedListPage-redux';

export default compose(
  withCitiesAndStreets
)(InspectedListPage);
